// Get the current hostname
const hostname = window.location.hostname;
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

// Use local backend for development, relative path for production
const backend_url = isLocalhost
  ? "http://localhost:5050/api"
  : "/api";

export default backend_url;